import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AllPortService } from 'src/app/services/all-port.service';
import { TestService } from 'src/app/services/test.service';
import Swal from 'sweetalert2';

declare var jQuery:any;
declare var $:any;

@Component({
  selector: 'app-all-port',
  templateUrl: './all-port.component.html',
  styleUrls: ['styles.css']
})
export class AllPortComponent implements OnInit {

  @ViewChild('instructions') instructions: ElementRef;

  public questions;
  public index;
  public answers=[];
  public orderAnswers=[];    ///////[0]=1    la primer pregunta primero [3]=4 la cuarta va ultima
  public actualIndex=0;
  public actualSelect;
  public testData;
  public photoTaked = false;
  public trigger = false;
  public selectedQuestion:any={
    "title":"",
    "opcA":{
      "factor":"",
      "text":""
    },
    "opcB":{
      "factor":"",
      "text":""
    },
    "opcC":{
      "factor":"",
      "text":""
    },
    "opcD":{
      "factor":"",
      "text":""
    },

  };

  public score = {
    "teorico":0,
    "economico":0,
    "estetico":0,
    "social":0,
    "politico":0,
    "religioso":0,
  }

  public userForm = this.fb.group({
    1:['', Validators.required],
    2:['', Validators.required],
    3:['', Validators.required],
    4:['', Validators.required],
    
  })

  public texts;
  constructor(private allPortService: AllPortService, private testService: TestService, private router:Router, private fb:FormBuilder) {

    this.allPortService.getQuestions().subscribe(
      resp=>{
        this.questions=resp;

        this.questions = this.questions.map( q => {
          let qNumber = q.title.split('- ')[0];
          let index = 0
          if (q.part == '1'){
            index = Number(qNumber)
          }else{
            index = Number(qNumber) + 40;
          }
          q.index = index;
          return q;
        })
        
        this.questions.sort((a, b) => {
          if (a.index > b.index) {
            return 1;
          }else{
            return -1;
          }
        });
      },
      err=>{

      }
    )
    if(!this.testService.selectedTestData){
      this.router.navigateByUrl('dashboard/requestedTests');
    }
    this.testData = this.testService.selectedTestData;
   }

  ngOnInit(): void {
  }

  reload(){
    location.reload();
  }

  ngAfterViewInit(){
    this.testService.getTexts().subscribe(
      resp=>{
        this.texts = resp;
        setTimeout(()=>{
          this.instructions.nativeElement.innerHTML = this.texts.allPortInstructions;
        }, 500)
      },
      err=>console.log(err)
    )    

  }

  startTest(){
    this.testService.testStarted = true;

    if (this.testData.camera){
      setTimeout(() => {
        this.trigger = !this.trigger;
      }, Math.floor(Math.random() * 60000 + 240000));
    }
    if(!this.userForm.valid){
      Swal.fire("Por favor, complete todos los campos").then(
        resp=>$('#myModal').modal('hide')
      );
    }else{
      var testData = this.testService.selectedTestData;
      testData.isStarted = true;
      testData.startDate = Date.now();
      this.testService.updateTest(testData).subscribe();
      
      this.actualIndex = 0;
      this.selectedQuestion = this.questions[0];
      this.index = 0;
      this.score = {
        "teorico":0,
        "economico":0,
        "estetico":0,
        "social":0,
        "politico":0,
        "religioso":0,
      };
      this.orderAnswers[0]=0;
      this.orderAnswers[1]=0;
      this.orderAnswers[2]=0;
      this.orderAnswers[3]=0;
  
      this.answers = [];
    }
    
  }

  skip(){
    this.index = this.index + 1;
    this.selectedQuestion = this.questions[this.index];
  }

  setSelected(opc){
    this.actualSelect = opc;
  }

  nextQuestion(opc){
    try {
      if(this.selectedQuestion.part=='1'){
        if(opc=='0'){
          const a = {
            1:"3",
            2:"0",
            3:"0",
            4:"0"
          }
          this.answers.push(a);
        }
        if(opc=='1'){
          const a = {
            1:"2",
            2:"1",
            3:"0",
            4:"0"
          }
          this.answers.push(a);
        }
        if(opc=='2'){
          const a = {
            1:"0",
            2:"3",
            3:"0",
            4:"0"
          }
          this.answers.push(a);
        }
        if(opc=='3'){
          const a = {
            1:"1",
            2:"2",
            3:"0",
            4:"0"
          }
          this.answers.push(a);
        }
        if(opc=='4'){
          const a = {
            1:"0",
            2:"0",
            3:"0",
            4:"0"
          }
          this.answers.push(a);
        }
        this.index = this.index + 1;
        this.selectedQuestion = this.questions[this.index];
        
  
      }else
  
      //PARTE 2 DEL TEST ////
  
      {
  
        if(this.actualIndex==4){
          var a = {
            1:String(5-this.orderAnswers[0]),
            2:String(5-this.orderAnswers[1]),
            3:String(5-this.orderAnswers[2]),
            4:String(5-this.orderAnswers[3])
          }
          this.answers.push(a);
  
          this.score[this.selectedQuestion.opcA.factor]=this.score[this.selectedQuestion.opcA.factor]+5-this.orderAnswers[0];
          this.score[this.selectedQuestion.opcB.factor]=this.score[this.selectedQuestion.opcB.factor]+5-this.orderAnswers[1];
          this.score[this.selectedQuestion.opcC.factor]=this.score[this.selectedQuestion.opcC.factor]+5-this.orderAnswers[2];
          this.score[this.selectedQuestion.opcD.factor]=this.score[this.selectedQuestion.opcD.factor]+5-this.orderAnswers[3];
       
          this.orderAnswers[0]=0;
          this.orderAnswers[1]=0;
          this.orderAnswers[2]=0;
          this.orderAnswers[3]=0;
          this.actualIndex=0;
          this.index = this.index + 1;
          this.selectedQuestion = this.questions[this.index];
          //console.log(this.index);
          //console.log(this.selectedQuestion);
          if(!this.selectedQuestion){
            this.trigger = !this.trigger;
            this.selectedQuestion = {
              "title":"Test finalizado",
              "opcA":{
                "factor":"",
                "text":""
              },
              "opcB":{
                "factor":"",
                "text":""
              },
              "opcC":{
                "factor":"",
                "text":""
              },
              "opcD":{
                "factor":"",
                "text":""
              },
              
            }
            //console.log(this.scoreConverted);
      
            Swal.fire({
              text:'Has concluido esta evaluación. Agradecemos tu participación',
              icon:'success',
              confirmButtonText:'Salir'
            });
            jQuery("#myModal").modal("hide");
            console.log(this.answers);
            this.allPortService.createReport(this.score, this.answers, this.userForm.value).subscribe(
              res=>{
                
                var testData = this.testService.selectedTestData;
                testData.isCompleted = true;
                testData.reportId = res._id;
                testData.completeDate = Date.now();
      
                this.testService.updateTest(testData).subscribe(
                  r=>{
      
                    this.router.navigateByUrl('dashboard/requestedTests');
                  },
                  e=>console.log(e)
                );
              },
              err=> console.log(err)
            )
            
          }
        }else{
          let timerInterval;
          Swal.fire({
            title: 'Debe seleccionar cuatro opciones',
            html: '',
            timer: 2000,
            timerProgressBar: true,
            
            onClose: () => {
              clearInterval(timerInterval)
            }
          }).then((result) => {
            /* Read more about handling dismissals below */
            if (result.dismiss === Swal.DismissReason.timer) {
              
            }
          })
        }
      }
      
      this.actualSelect=undefined;
      
    } catch (error) {
      console.log(error)
    }
  }

  select(opc){

    if(this.selectedQuestion.part=='1'){
      if(opc=='0'){
        this.score[this.selectedQuestion.opcA.factor]=this.score[this.selectedQuestion.opcA.factor]+3;
      }
      if(opc=='1'){
        this.score[this.selectedQuestion.opcA.factor]=this.score[this.selectedQuestion.opcA.factor]+2;
        this.score[this.selectedQuestion.opcB.factor]=this.score[this.selectedQuestion.opcB.factor]+1;
      }
      if(opc=='2'){
        this.score[this.selectedQuestion.opcB.factor]=this.score[this.selectedQuestion.opcB.factor]+3;
      }
      if(opc=='3'){
        this.score[this.selectedQuestion.opcA.factor]=this.score[this.selectedQuestion.opcA.factor]+1;
        this.score[this.selectedQuestion.opcB.factor]=this.score[this.selectedQuestion.opcB.factor]+2;
      }

      this.nextQuestion(opc);
    }else{
      if (opc=='4'){
        this.orderAnswers[0]=5;
        this.orderAnswers[1]=5;
        this.orderAnswers[2]=5;
        this.orderAnswers[3]=5;
        this.actualIndex=4;
        this.nextQuestion(opc);
      }
      if (opc=='5'){
        this.nextQuestion(opc);
      }else{
        if(this.actualIndex<=4){
          for (var i = 0; i<=this.actualIndex; i++){
            if(this.orderAnswers[(parseInt(opc))]!=0){
              added = true;
            }
          }
          if (!added){
            this.orderAnswers[opc]=this.actualIndex+1;
            this.actualIndex++; 
          }
        }

      }
      var added = false;
    }
  }

  clear(){
    this.orderAnswers[0]=0;
    this.orderAnswers[1]=0;
    this.orderAnswers[2]=0;
    this.orderAnswers[3]=0;
    this.actualIndex=0;
  }


}
